import React from 'react';
import PropTypes from 'prop-types';

const Select = (props) => (
    <select
        className = { props.className }
        onChange = { props.controlFunc }
    >
        {props.options.map(opt => {
            return (
                <option
                    key={opt.displayText}
                    value={opt.value}>{opt.displayText}</option>
            );
        })}
    </select>)

    Select.propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
    }

export default Select;
